module.exports = ".chart-padding {\n  padding: 25px 15px 5px;\n}\n"